
import Hero from '@/components/work-with-me/Hero'
import HereToHelp from '@/components/work-with-me/HereToHelp'
import FAQs from '@/components/work-with-me/FAQs'
import HaveQuestionsContainer from '@/components/work-with-me/HaveQuestionsContainer'
import ThreeDifferentWays from '@/components/work-with-me/ThreeDifferentWays'
import WhatOthersAreSaying from '@/components/work-with-me/WhatOthersAreSaying'
export default {
  name: 'WorkWithMePage',
  components: {
    WhatOthersAreSaying,
    ThreeDifferentWays,
    FAQs,
    HereToHelp,
    HaveQuestionsContainer,
    Hero,
  },
  layout: 'noheader',
  data() {
    return {
      title: `Services | ${this.$config.siteTitle}`,
      description:
        'From 1:1 nutrition coaching to personal chef services to recipe ebooks, Plants So Good is your resource for all things plant-based.',
    }
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.description,
        },
        { hid: 'og:title', property: 'og:title', content: this.title },
        { hid: 'og:url', property: 'og:url', content: this.pageUrl },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.description,
        },

        // twitter card
        { hid: 'twitter:title', name: 'twitter:title', content: this.title },
        { hid: 'twitter:url', name: 'twitter:url', content: this.pageUrl },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content: this.description,
        },
        {
          hid: 'og:image',
          name: 'og:image',
          content: '/images/work-with-me/og.png',
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          content: '/images/work-with-me/og.png',
        },
        {
          hid: 'og:image:width',
          name: 'og:image:width',
          content: '1200',
        },
        {
          hid: 'og:image:height',
          name: 'og:image:height',
          content: '630',
        },
      ],
    }
  },
  computed: {
    pageUrl() {
      return `${this.$config.baseURL}${this.$route.fullPath}`
    },
  },
}
